import classNames from "classnames";

export declare namespace KeyboardLine {
  export interface Props {
    className?: string;
    children: React.JSX.Element | React.JSX.Element[];
  }
}

export function KeyboardLine({ className, children }: KeyboardLine.Props) {
  return (
    <div className={classNames(className, "flex justify-center min-w-0")}>
      {children}
    </div>
  );
}
